<template>
  <div class="h-full">
    <locationSettingVulkan :moduleName="moduleName" v-if="modelSettings.cloudRenderVersion === 5">
    </locationSettingVulkan>
    <locationSetting :moduleName="moduleName" v-else> </locationSetting>
  </div>
</template>

<script>
import locationSetting from '../../../../wiz-tag-3d-position-management-tongre/views/tag3dPosition/monitor-location-setting/index'
import locationSettingVulkan from '../../../../wiz-tag-3d-position-management-tongre/views/tag3dPosition/position-setting-vulkan/index'

const componentName = 'monitor-location-setting'

export default {
  name: componentName,
  components: {
    locationSetting,
    locationSettingVulkan,
  },
  computed: {
    // 模型相关设置
    modelSettings() {
      return _.get(Wiz, 'globalSettings.globalConfig')?.modelSetting || {}
    },
  },
  data() {
    return {
      moduleName: 'wiz-iot-management-tongre',
    }
  },
}
</script>

<style lang="scss" scoped></style>
